import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import type {
  IMultiStateBoxPlatformProps,
  MultiStateBoxDefinition,
} from '../MultiStateBox.types';
import { getStateToRender } from './utils';

export const props = withCompInfo<
  IMultiStateBoxPlatformProps,
  MultiStateBoxDefinition,
  IMultiStateBoxPlatformProps
>()(
  ['compId', 'compData', 'structure', 'isMasterPage'],
  ({ compId, compData, structure, isMasterPage }, carmiData) => {
    const { a11y, defaultStateId, selectedStateId } = compData;

    const stateIds = structure.components ?? [];

    return {
      ...carmiData,
      a11y,
      selectedStateId: getStateToRender({
        defaultStateId,
        selectedStateId,
        stateIds,
        msbId: compId,
        isEditing: false,
      }),
      isMasterPage,
    };
  },
);

export const stateRefs = withStateRefsValues([
  'observeChildListChange',
  'observeChildListChangeMaster',
]);

export default createComponentMapperModel({ props, stateRefs });
